import type { CasinoIcon } from '@swf/casino';

export const sequencesDef: CasinoIcon[][] = [
  ['icnSquare'],
  ['icnWide', 'icnWide'],
  ['icnWide', 'icnSquare', 'icnSquare'],
  ['icnSquare', 'icnSquare', 'icnSquare', 'icnSquare'],
  ['icnSquare', 'icnSquare', 'icnSquare', 'icnWide', 'icnSquare'],
  ['icnWide', 'icnSquare', 'icnSquare', 'icnWide', 'icnWide', 'icnSquare'],
  ['icnWide', 'icnSquare', 'icnSquare', 'icnWide', 'icnSquare', 'icnSquare', 'icnSquare'],
  [
    'icnWide',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare'
  ],
  [
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare',
    'icnSquare'
  ]
];

export const sequencesSl: CasinoIcon[][] = [
  ['icnPoster'],
  ['icnWide', 'icnWide'],
  ['icnWide', 'icnPoster', 'icnPoster'],
  ['icnPoster', 'icnPoster', 'icnPoster', 'icnPoster'],
  ['icnPoster', 'icnPoster', 'icnPoster', 'icnWide', 'icnPoster'],
  ['icnWide', 'icnPoster', 'icnPoster', 'icnWide', 'icnWide', 'icnPoster'],
  ['icnWide', 'icnPoster', 'icnPoster', 'icnWide', 'icnPoster', 'icnPoster', 'icnPoster'],
  [
    'icnWide',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster'
  ],
  [
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster',
    'icnPoster'
  ]
];
